import config from '../config';

const { ANALYTICS_DEBUG } = config;
const GA_ACTION_SEND = 'send';
const GA_TYPE_PAGEVIEW = 'pageview';
const GA_TYPE_EVENT = 'event';

const internal = {
  getTracker() {
    return window.ga || null;
  },
};

export default {
  trackPage(values) {
    const tracker = internal.getTracker();
    if (tracker) {
      if (ANALYTICS_DEBUG) {
        console.log(`GA::${GA_TYPE_PAGEVIEW.toUpperCase()}:: ${values.url}`);
      }
      tracker(GA_ACTION_SEND, GA_TYPE_PAGEVIEW, values.url);
    }
  },
  trackEvent(category, action, label = null, value = null) {
    const tracker = internal.getTracker();
    if (tracker) {
      const page = { page: window.location.pathname };
      if (ANALYTICS_DEBUG) {
        console.log(`GA::${GA_TYPE_EVENT.toUpperCase()}::`, category, action, label, value);
      }
      if (label === null && value === null) {
        tracker(GA_ACTION_SEND, GA_TYPE_EVENT, category, action, page);
      } else if (label !== null && value === null) {
        tracker(GA_ACTION_SEND, GA_TYPE_EVENT, category, action, label, page);
      } else if (label !== null && value !== null) {
        tracker(GA_ACTION_SEND, GA_TYPE_EVENT, category, action, label, value, page);
      }
    }
  },
};
